"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import MemeDropTrait from "./MemeDropTrait";
import { FIELD_TO_LABEL_MAP, MEME_TRAITS_SORT_ORDER } from "@/components/waves/memes/traits/schema";
interface MemeDropTraitsProps {
  readonly drop: ApiDrop;
}
interface MemeDropTrait {
  label: string;
  value: string;
}
const MemeDropTraits: React.FC<MemeDropTraitsProps> = t0 => {
  const $ = _c(18);
  const {
    drop
  } = t0;
  const [showAllTraits, setShowAllTraits] = useState(false);
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== drop.id || $[1] !== drop.metadata || $[2] !== showAllTraits) {
    const traits = drop.metadata.sort(_temp);
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = e => {
        e.stopPropagation();
        setShowAllTraits(false);
      };
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    const handleShowLess = t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = e_0 => {
        e_0.stopPropagation();
        setShowAllTraits(true);
      };
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const handleShowAll = t6;
    t4 = "lg:tw-flex tw-flex-col tw-gap-2 tw-hidden";
    t1 = "tw-grid tw-grid-cols-2 sm:tw-grid-cols-4 tw-gap-2";
    let t7;
    if ($[9] !== drop.id) {
      t7 = trait => <MemeDropTrait key={trait.data_key} label={FIELD_TO_LABEL_MAP[trait.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait.data_value ?? ""} dropId={drop.id} />;
      $[9] = drop.id;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t2 = traits.slice(0, 2).map(t7);
    t3 = showAllTraits ? <>{traits.slice(2).map(trait_0 => <MemeDropTrait key={trait_0.data_key} label={FIELD_TO_LABEL_MAP[trait_0.data_key as keyof typeof FIELD_TO_LABEL_MAP]} value={trait_0.data_value ?? ""} dropId={drop.id} />)}<button onClick={handleShowLess} className="tw-text-primary-400 tw-text-xs tw-text-left tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors tw-whitespace-nowrap tw-self-end tw-pb-1.5 tw-bg-transparent tw-border-0">Show less</button></> : <button onClick={handleShowAll} className="tw-text-primary-400 tw-text-xs tw-text-left tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors tw-whitespace-nowrap tw-self-end tw-pb-1.5 tw-bg-transparent tw-border-0">Show all</button>;
    $[0] = drop.id;
    $[1] = drop.metadata;
    $[2] = showAllTraits;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default MemeDropTraits;
function _temp(a, b) {
  const aIndex = MEME_TRAITS_SORT_ORDER.indexOf(a.data_key);
  const bIndex = MEME_TRAITS_SORT_ORDER.indexOf(b.data_key);
  return aIndex - bIndex;
}